<template>
  <div>
    <div class="row">
      <div class="col-md-6 start-date">
        <strong class="d-block mb-3">
          {{ i18n.t('events.form.start_time') }}
        </strong>
        <date-picker :initial-value="startAt"
                     input-id="start-time-input"
                     :time-zone="timeZone"
                     :show-time-meridian="showTimeMeridian"
                     disable-past
                     mode="dateTime"
                     @change="setStartAt" @change-by-user="setTimesOverridden" />
      </div>
      <div class="col-md-6 end-date">
        <div class="d-grid gap-3">
          <strong class="d-block">
            {{ i18n.t('events.form.end_time') }}
          </strong>

          <date-picker v-if="endAt"
                       :initial-value="endAt"
                       input-id="end-time-input"
                       :time-zone="timeZone"
                       :show-time-meridian="showTimeMeridian"
                       disable-past
                       mode="dateTime"
                       @change="setEndAt" @change-by-user="setTimesOverridden" />

          <light-button v-else class="add-end-time-button btn-light-tinted" @click="initializeEndAt">
            {{ i18n.t('events.form.add_end_time') }}
          </light-button>

          <light-button v-if="endAt" class="btn-light-tinted" @click="removeEndAt">
            {{ i18n.t('administrative.remove') }}
          </light-button>
        </div>
      </div>
    </div>
    <validation-errors v-if="dateValidationErrors.length" :errors="dateValidationErrors" />
  </div>
</template>

<script>
import LightButton from '@/components/buttons/light-button'
import ValidationErrors from '@/components/inputs/validation-errors.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import DatePicker from '@/components/inputs/date-time/date-picker.vue'

export default {
  components: { LightButton, ValidationErrors, DatePicker },

  computed: {
    ...mapState(['showTimeMeridian']),
    ...mapGetters(['dateValidationErrors', 'endAt', 'startAt', 'timeZone', 'virtual'])
  },

  methods: {
    ...mapMutations(['initializeEndAt', 'removeEndAt', 'setEndAt', 'setStartAt', 'setTimesOverridden'])
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep(.date-picker-input) {
    font-size: 1rem;
    border-radius: 8px;
    padding: 13px 10px;
    height: 58px;
  }

  .btn-light-tinted {
    height: 50px;
    text-transform: none;
    font-weight: bold;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .add-end-time-button {
    height: 58px;
  }

  // Override styles defined in field-layout that break date time picker's fields
  ::v-deep(.vc-date-picker-content select) {
    padding: 0 20px 0 4px;
    font-size: 16px;
    margin-bottom: 0;
    height: 30px;
  }
  ::v-deep(input) {
    margin-bottom: 0;
  }
</style>
